import PATHS from '../constants';

function fetchFeatures() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.ABOUT_US_FEATURES, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchFeatures;